import { render, staticRenderFns } from "./PorAnoAtoAdministrativo.vue?vue&type=template&id=55925612&scoped=true"
import script from "./PorAnoAtoAdministrativo.vue?vue&type=script&lang=js"
export * from "./PorAnoAtoAdministrativo.vue?vue&type=script&lang=js"
import style0 from "./PorAnoAtoAdministrativo.vue?vue&type=style&index=0&id=55925612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55925612",
  null
  
)

export default component.exports